module.exports = __webpack_public_path__ + "img/bian_icon.c1d57eb1.png";